import { MutationTree } from 'vuex';
import { FamilyState } from './state';

export const mutations: MutationTree<FamilyState> = {
  SET_FAMILIES(state, list: any[]) {
    state.families = list;
  },
  SET_FAMILIES_LOADING(state, loading: boolean) {
    state.familiesLoading = loading;
  },
  SET_FAMILIES_ERROR(state, err: string | null) {
    state.familiesError = err;
  },
  ADD_FAMILY(state, family: any) {
    state.families = [family, ...state.families.filter(f => f.id !== family.id)];
  },
  UPDATE_FAMILY(state, family: any) {
    state.families = state.families.map(f => (f.id === family.id ? family : f));
  },
  REMOVE_FAMILY(state, familyId: string) {
    state.families = state.families.filter(f => f.id !== familyId);
    if (state.activeFamilyId === familyId) {
      state.activeFamilyId = null;
      state.activeSubgraph = null;
    }
  },

  SET_ACTIVE_FAMILY_ID(state, id: string | null) {
    state.activeFamilyId = id;
  },
  SET_ACTIVE_SUBGRAPH(state, subgraph: FamilyState['activeSubgraph']) {
    state.activeSubgraph = subgraph;
  },
  SET_ACTIVE_SUBGRAPH_LOADING(state, loading: boolean) {
    state.activeSubgraphLoading = loading;
  },
  SET_ACTIVE_SUBGRAPH_ERROR(state, err: string | null) {
    state.activeSubgraphError = err;
  },

  // Granular updates to active subgraph
  ADD_MEMBER(state, member: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.members = [...state.activeSubgraph.members, member];
  },
  UPDATE_MEMBER(state, member: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.members = state.activeSubgraph.members.map(m =>
      m.id === member.id ? member : m
    );
  },
  REMOVE_MEMBER(state, memberId: string) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.members = state.activeSubgraph.members.filter(m => m.id !== memberId);
    state.activeSubgraph.relationships = state.activeSubgraph.relationships.filter(
      r => r.fromMemberId !== memberId && r.toMemberId !== memberId
    );
    if (state.selectedMemberId === memberId) state.selectedMemberId = null;
  },
  ADD_RELATIONSHIP(state, rel: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.relationships = [...state.activeSubgraph.relationships, rel];
  },
  REMOVE_RELATIONSHIP(state, relationshipId: string) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.relationships = state.activeSubgraph.relationships.filter(
      r => r.id !== relationshipId
    );
  },
  ADD_PHOTO(state, photo: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.photos = [photo, ...state.activeSubgraph.photos];
  },
  REMOVE_PHOTO(state, photoId: string) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.photos = state.activeSubgraph.photos.filter(p => p.id !== photoId);
    state.activeSubgraph.faceCrops = state.activeSubgraph.faceCrops.filter(
      fc => fc.photoId !== photoId
    );
  },
  ADD_FACE_CROP(state, crop: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.faceCrops = [...state.activeSubgraph.faceCrops, crop];
  },
  UPDATE_FACE_CROP(state, crop: any) {
    if (!state.activeSubgraph) return;
    state.activeSubgraph.faceCrops = state.activeSubgraph.faceCrops.map(fc =>
      fc.id === crop.id ? crop : fc
    );
  },

  SET_SELECTED_MEMBER_ID(state, id: string | null) {
    state.selectedMemberId = id;
  },
  SET_WIZARD_OPEN(state, open: boolean) {
    state.wizardOpen = open;
  },

  SET_PUBLIC_SUBGRAPH(state, subgraph: FamilyState['publicSubgraph']) {
    state.publicSubgraph = subgraph;
  },
  SET_PUBLIC_SUBGRAPH_LOADING(state, loading: boolean) {
    state.publicSubgraphLoading = loading;
  },
  SET_PUBLIC_SUBGRAPH_ERROR(state, err: string | null) {
    state.publicSubgraphError = err;
  }
};
